import React from "react";
import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useGuestSession } from "contexts/GuestSessionContext";
import {
  normalizeGuestType,
  resolveGuestLandingPath,
  withGuestSearch,
} from "data/guestPortalDefaults";

const GuestLandingRedirect = ({ children }) => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const { table } = useGuestSession();

  const isHub =
    location.pathname === "/guest" || location.pathname === "/guest/";

  if (!isHub) {
    return children;
  }

  const type =
    normalizeGuestType(
      searchParams.get("guestType") || searchParams.get("type")
    ) || normalizeGuestType(table?.type);

  const tableId = searchParams.get("tableId") || table?.id;
  const landingPath = resolveGuestLandingPath(type, tableId);
  if (landingPath !== "/guest") {
    return (
      <Navigate to={withGuestSearch(landingPath, location.search)} replace />
    );
  }

  return children;
};

export default GuestLandingRedirect;
